export default __webpack_public_path__ + "static/1124-a8ed58c8d2373dccee57950a7b7a00cb.gif";